import { Pipe, PipeTransform } from '@angular/core';
import DOMPurify from 'dompurify';

@Pipe({
    name: 'purify',
    pure: true,
    standalone: false,
})
export class PurifyPipe implements PipeTransform {
    transform(str: any, customTags: string[] = ['b'], customAttributes: string[] = []): any {
        let res = str;
        if (str === null || str === undefined || str === '' || str === 0) {
            res = '--';
        }

        // allowed tags to be added later
        return DOMPurify.sanitize(res, {
            ALLOWED_TAGS: customTags,
            ADD_ATTR: customAttributes,
        });
    }
}
